<template>
    <el-container>

        <el-main>
            <el-form ref="searchDate" :model="searchData" label-width="80px" label-position="top">
                <el-row >
                    <el-col :span="4" class="cls-col">
                        <el-form-item label="订单号" prop="orderNo">
                            <el-input v-model="searchData.orderNo" placeholder="订单号" size="small" ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4" class="cls-col">
                        <el-form-item label="用户名" prop="userName" >
                            <el-input v-model="searchData.userName" placeholder="用户名" size="small" ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4" class="cls-col">
                        <el-form-item label="护照名" prop="passportFirstName">
                            <el-input v-model="searchData.passportFirstName" placeholder="护照名" size="small" ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4" class="cls-col">
                        <el-form-item label="生源" prop="studentPool">
                            <el-input v-model="searchData.studentPool" placeholder="生源" size="small" ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4" class="cls-col">
                        <el-form-item label="支付状态" prop="paymentStatus">
                            <el-select v-model="searchData.paymentStatus" clearable  placeholder="支付状态" size="small" style="width: 100%">
                                <el-option label="已支付" :value="1"></el-option>
                                <el-option label="未支付" :value="0"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4" class="cls-col">
                        <el-form-item label="支付方式" prop="paymentStatus">
                            <el-select v-model="searchData.payType" clearable  placeholder="支付方式" size="small" style="width: 100%">
                                <el-option label="支付宝/微信支付" :value="2"></el-option>
                                <el-option label="银行汇款" :value="3"></el-option>
                                <el-option label="现场支付" :value="4"></el-option>
                                <el-option label="首信易支付" :value="6"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4" class="cls-col">
                        <el-form-item label="是否需要开发票" prop="isBill" >
                            <el-select v-model="searchData.isBill" clearable  placeholder="是否需要开发票" size="small" style="width: 100%">
                                <el-option label="是" :value="1"></el-option>
                                <el-option label="否" :value="0"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" >
                        <el-form-item label="支付时间" prop="phone" >
                            <el-date-picker
                                size="small"
                                style="width: 80%"
                                v-model="paymentTime"
                                type="daterange"
                                range-separator="至"
                                @change="changeTime"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row >
                    
                    <!--<el-col :span="4" class="cls-col">
                        <el-form-item label="是否已开发票" prop="isdrawBill" >
                            <el-select v-model="searchData.isdrawBill" clearable  placeholder="是否已开发票" size="small" style="width: 100%">
                                <el-option label="是" :value="1"></el-option>
                                <el-option label="否" :value="0"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" >
                        <el-form-item label="创建日期" prop="phone" >
                            <el-date-picker
                                size="small"
                                style="width: 80%"
                                v-model="createTime"
                                type="daterange"
                                range-separator="至"
                                @change="changeTime"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>-->
                </el-row>
                <el-form-item >
                    <el-button type="primary" plain size="small" icon="el-icon-search" @click="onSubmit()">查询</el-button>
                    <el-button type="primary" size="small" icon="el-icon-upload" @click="exportExcel()" :disabled="isExport">导出缴费确认表</el-button>
                </el-form-item>
            </el-form>
            <el-dialog
                title="用户详情"
                :visible.sync="detailDialog.show"
                width="30%"
                :close-on-click-modal=false
                :before-close="handleDetailClose"
                id="detailDialog"
            >
                <el-form class="demo-ruleForm" align="left" label-width="100px">
                    <el-form-item label="用户名：" prop="userName">{{detailDialog.data.userName}}</el-form-item>
                    <el-form-item label="听说渠道" prop="referralSource">{{detailDialog.data.referralSource}}</el-form-item>
                    <el-form-item label="手机号：" prop="phone">{{detailDialog.data.phone}}</el-form-item>
                    <el-form-item label="头像：" prop="headerUrl">
                        <img style="height:90px" :src="detailDialog.data.headerUrl" />
                    </el-form-item>
                    <el-form-item label="密码：" prop="password">--</el-form-item>
                    <el-form-item label="姓名：" prop="realName">{{detailDialog.data.realName}}</el-form-item>
                    <el-form-item label="性别：" prop="sex">{{detailDialog.data.sex | sexFilter}}</el-form-item>
                    <el-form-item label="邮箱：" prop="email">{{detailDialog.data.email}}</el-form-item>
                    <el-form-item label="学历：" prop="education">{{detailDialog.data.education}}</el-form-item>
                    <el-form-item label="所在省份：" prop="province">
                        {{detailDialog.data.provinceName}}{{detailDialog.data.cityName}}{{detailDialog.data.districtName}}
                    </el-form-item>
                    <el-form-item label="QQ：" prop="qq">{{detailDialog.data.qq}}</el-form-item>
                    <el-form-item label="收货地址：" prop="consigneeAddress">{{detailDialog.data.consigneeAddressAll}}</el-form-item>
                    <el-form-item label="护照姓：" prop="passportFirstName">{{detailDialog.data.passportFirstName}}</el-form-item>
                    <el-form-item label="护照名：" prop="passportLastName">{{detailDialog.data.passportLastName}}</el-form-item>
                    <el-form-item label="国籍：" prop="nationalityZh">{{detailDialog.data.nationalityZh}}</el-form-item>
                    <el-form-item prop="birthday" label="生日：" v-if="loginOrgCode == 'blcuonline'">{{detailDialog.data.birthday | dateFormatFilter}}</el-form-item>
                    <el-form-item prop="originSource" label="生源：" v-if="loginOrgCode == 'blcuonline'">{{detailDialog.data.originSource}}</el-form-item>
                    <el-form-item prop="createTime" label="注册日期："   :formatter="createTimeFormat">{{detailDialog.data.createTime | dateFormatFilter1}}</el-form-item>
                    <el-form-item label="现居地：" prop="address">{{detailDialog.data.address}}</el-form-item>
        
                </el-form>
            </el-dialog>
            <el-table
                :data="staffData"
                border
                highlight-current-row
                v-loading="loading"
                style="width: 100%"
            >
                <el-table-column
                    type="index"
                    label="序号"
                    width="50"
                    align="center"
                    fixed="left"
                >
                </el-table-column>
                <el-table-column
                    prop="orderNo"
                    label="订单号"
                    width="200"
                    fixed="left"
                >
                </el-table-column>
                <el-table-column
                    label="用户名"
                    width="150"
                >
                    <template slot-scope="scope">
                        <el-button  type="text" style="font-size: 15px" @click="showUser(scope.row)" >{{scope.row.userName}}</el-button>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="passportFirstName"
                    label="护照名"
                    width="130"
                    :formatter="f_passportName"
                >
                </el-table-column>
                <el-table-column
                    label="生源"
                    width="130"
                    prop="studentPool"
                >
                </el-table-column>
                <el-table-column
                    prop="paymentStatus"
                    label="支付状态"
                    width="100"
                    :formatter="f_orderStatus"
                >
                </el-table-column>
                <el-table-column
                    prop="payType"
                    label="支付方式"
                    width="100"
                    :formatter="f_payType"
                >
                </el-table-column>
                <el-table-column
                    label="应付金额"
                    width="100"
                    align="center"
                    :formatter="f_amount"
                >
                    <!--<template slot-scope="scope">-->
                        <!--<el-button v-if="!payInput[scope.row.orderId]"  type="text" style="font-size: 15px" @click="showInput(scope.row)" >{{scope.row.amount | payFilter}}</el-button>-->
                        <!--<el-input v-if="payInput[scope.row.orderId]" v-model="scope.row.amount" width="80%" size="small" @blur="editTotal(scope.row)" @input="validateNumber(scope.row.amount,(data)=>{scope.row.amount = data})" maxLength='9'></el-input>-->
                    <!--</template>-->
                </el-table-column>
                <el-table-column
                    label="到账金额"
                    width="100"
                    align="center"
                    prop="realPay"
                >
                    <!--<template slot-scope="scope">-->
                        <!--<el-button v-if="!realPayInput[scope.row.orderId]"  type="text" style="font-size: 15px" @click="showRealPayInput(scope.row)" >{{scope.row.realPay | payFilter}}</el-button>-->
                        <!--<el-input v-if="realPayInput[scope.row.orderId]" v-model="scope.row.realPay" width="80%" size="small" @blur="editRealPay(scope.row)" @input="validateNumber(scope.row.realPay,(data)=>{scope.row.realPay = data})" maxLength='9'></el-input>-->
                    <!--</template>-->
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    label="提交时间"
                    width="180"
                    :formatter="dateFormat"
                >
                </el-table-column>
                <el-table-column
                    prop="paymentTime"
                    label="支付时间"
                    width="180"
                    :formatter="dateFormat"
                >
                </el-table-column>
                <el-table-column
                    prop="isStatement"
                    label="是否需要对账"
                    width="130"
                    :formatter="f_isBill"
                >
                </el-table-column>
    
                <el-table-column
                    prop="isBill"
                    label="是否需要发票"
                    width="130"
                    :formatter="f_isBill"
                >
                </el-table-column>
                
                <el-table-column
                    fixed="right"
                    label="操作"
                    width="160"
                >
                    <template slot-scope="scope">
                        <el-button @click="detail(scope.row)" type="text" size="small">查看</el-button>
                        <!--<el-button @click="confirmBill(scope.$index, scope.row)" type="text" size="small" v-if="scope.row.paymentStatus == 1 && scope.row.isBill == 1 && scope.row.isdrawBill == 0">确认开票</el-button>-->
                        <el-button @click="pay(scope.$index, scope.row)" type="text" size="small" v-if="scope.row.paymentStatus == 0 && scope.row.payType == 3">汇款购买</el-button>
                        <!--<el-button @click="pay(scope.$index, scope.row)" type="text" v-if="scope.row.paymentStatus == 3" size="small" >汇款购买</el-button>-->
                        <!--<el-button @click="pos(scope.$index, scope.row)" type="text" size="small" v-if="scope.row.payType == 4 ">易宝POS机支付</el-button>-->
                        <el-button @click="deleteOrder(scope.$index, scope.row)" type="text" size="small" v-if="scope.row.paymentStatus ==0" >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            
            <el-pagination
                background
                layout="prev, pager, next"
                :total="total"
                :page-size="pageSize"
                :current-page.sync="currentPage"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                style="margin-top: 10px; float: right; margin-right: 10px">
            </el-pagination>
        </el-main>
    </el-container>
</template>

<script>
  import https from '@/https.js'
  import validate from '@/api/validate.js'
  import {dateFormat} from '@/api/utils.js'
  import Base64 from '@/api/video/lib/base64.js'
  import qs from 'qs'

  export default {
    name: "order",
    data() {
      return {
        paymentTime: [],
        loginOrgCode: '',
        loading: true,
        searchData: {
          createTimeStart: "",
          createTimeEnd: "",
          paymentTimeStart: "",
          paymentTimeEnd: "",
          orderNo: "",
          userName: "",
          isdrawBill: "",
          isBill: "",
          isStatement: "",
          org: "",
          size: 0,
          paymentStatus: '',
          payType: '',
          passportName: '',
          nationality: '',
          page: 1,
        },
        nationalityEdit: {},
        org: [],
        createTime: [],
        rules: {
          userName: [
            { required: true, message: '请输入用户名', trigger: 'blur' },
            { min: 6, max: 20, message: '长度为6-20 个字符', trigger: 'blur' }
          ],
          phone: [
            {required: true, message: '请输入电话', trigger: 'blur' },
            { validator: validate.validatePhone, trigger: 'blur' }
          ],
          realName: [
            { max:50, message: '长度不得超过50个字符', trigger: 'blur' }
          ],
          email: [
            { validator: validate.validateEmail, trigger: 'blur' }
          ],
          qq: [
            { validator: validate.validateQQ, trigger: 'blur' }
          ],
          education: [
            { max:50, message: '长度不得超过50个数字', trigger: 'blur' }
          ],
          province: [
            { max:50, message: '长度不得超过50个数字', trigger: 'blur' }
          ],
        },
        total: 0,
        pageSize:10,
        currentPage: 1,
        addStaff: false,
        staffData: [],
        isUpdate: false,
        isExport: true,
        payInput: {},
        realPayInput: {},
        detailDialog: {
          data: {},
          show: false
        }
      }
    },
    watch: {
      'searchData.paymentStatus'(val) {
        if(val == 1) {
          this.isExport = false;
        } else {
          this.isExport = true;
        }
      }
    },
    methods: {
      handleDetailClose() {
        this.detailDialog.show = false;
      },
      createTimeFormat(row, column, cellValue, index) {
        if(cellValue) {
          return dateFormat(cellValue).substr(0,16);
        }
      },
      showUser(item) {

        let params = {
          userName: item.userName
        };
        this.detailDialog.data = {};
        let that = this;
        https
            .fetchPost('/managerStudent/findUser', params, 'json')
            .then((res) => {
              let code = res.data.code;
              let msg = res.data.msg;
              if (code == 200) {
                if(res.data.data[0]) {
                  this.detailDialog.data = res.data.data[0];
                }
              } else {
                this.$message({
                  type: 'info',
                  message: msg
                });
              }
            })
            .catch(() => {
              this.$message.error('网络错误，请联系管理员');
            });

        this.detailDialog.show = true;
      },
      showRealPayInput(item) {
        let oldRealPay = item.realPay;
        this.realPayInput = {};
        this.$set(this.realPayInput, item.orderId, true);
        this.$set(this.realPayInput, "realPay", oldRealPay);
      },
      editRealPay(item) {
        let oldRealPay = this.realPayInput.realPay;
        this.realPayInput = {};
        // /mallOrderInfo/pricing
        let params = {
          orderId: item.orderId,
          realPay: item.realPay,
        };
        https.fetchPost('/mallOrderInfo/pricing',params ,"json" ).then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if(code == '200') {
            this.$message({
              type: 'success',
              message: '修改成功!'
            });
          } else {
            this.$message({
              type: 'info',
              message: msg
            })
            item.realPay = oldRealPay;
          }
        }).catch(err=>{
              this.$message.error('数据加载失败');
            }
        )


      },
      showInput(item) {
        this.payInput = {};
        let amount = item.amount
        this.$set(this.payInput, item.orderId, true);
        this.$set(this.payInput, "amount", amount);
      },
      deleteOrder(index, row) {
        this.$confirm('此操作将删除该订单, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
              let params = {
                orderId: row.orderId,
                orderStatus: 0
              };
              https
                  .fetchPost('/mallOrderInfo/updateMallOrderInfoVoByOrderIdAndPay', params, 'json')
                  .then((data) => {
                    let code = data.data.code;
                    let msg = data.data.msg;
                    if (code == '200') {
                      this.$message({
                        type: 'success',
                        message: '删除成功!'
                      });
                      this.onSubmit();
                    } else {
                      this.$message({
                        type: 'info',
                        message: '删除失败:' + msg
                      });
                    }
                  })
                  .catch((err) => {
                    this.$message.error('网络异常！');
                  });
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              });
            });
      },
      editTotal(item) {
        let oldAmount = this.payInput.amount
        this.payInput = {};
        // /mallOrderInfo/pricing
        let params = {
          orderId: item.orderId,
          amount: item.amount,
        };
        https.fetchPost('/mallOrderInfo/pricing',params ,"json" ).then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if(code == '200') {
            this.$message({
              type: 'success',
              message: '修改成功!'
            });
          } else {
            this.$message({
              type: 'info',
              message: msg
            })
            item.amount = oldAmount;
            
          }
        }).catch(err=>{
              this.$message.error('数据加载失败');
            }
        )
        
        
      },
      validateNumber(value) {
        value = value.replace(/[^\d]/g,'');

       /* if(isNaN(value)) {
          value = null;
        }
        if(value.indexOf('.')>0){
          value=value.slice(0,value.indexOf('.')+3);
        }*/
      },
      f_isdrawBill(row, column, cellValue, index) {
        if(cellValue == 0) {
          return '否';
        }
        if(cellValue == 1) {
          return '是';
        }
      },
      f_isBill(row, column, cellValue, index) {
        if(cellValue == 0) {
          return '否';
        }
        if(cellValue == 1) {
          return '是';
        }
      },
      f_orderStatus(row, column, cellValue, index) {
        if(cellValue == 0) {
          return '未支付';
        }
        if(cellValue == 1) {
          return '已支付';
        }
        if(cellValue == 2) {
          return '支付中';
        }
        if(cellValue == 3) {
          return '支付失败';
        }
      },
      f_amount(row, column, cellValue, index) {
        if(row.total) {
          return row.total
        } else {
          return row.amount
        }
      },
      f_payType(row, column, cellValue, index) {
        if(cellValue == 0) {
          return '无';
        }
        if(cellValue == 1) {
          return '易宝支付';
        }
        if(cellValue == 2) {
          return '支付宝/微信支付';
        }
        if(cellValue == 3) {
          return '银行汇款';
        }
        if(cellValue == 4) {
          return '现场支付';
        }
        if(cellValue == 5) {
          return '微信支付';
        }
        if(cellValue == 6) {
          return '首信易支付';
        }
      },
      validateNumber(value,collback) {
        value = value.replace(/[^\d.]/g,''); // 清除"数字"和"."以外的字符
        value = value.replace(/^\./g,''); // 验证第一个字符是数字
        value = value.replace(/\.{2,}/g,'.'); // 只保留第一个, 清除多余的
        value = value.replace('.','$#$').replace(/\./g,'').replace('$#$','.');
        // 保存n个小数
        value = value.replace(/^(\-)*(\d+)\.(\d{2}).*$/,'$1$2.$3');         // 只能输入n个小数
        if(value.indexOf('.') < 0 && value !=''){
          value = parseFloat(value);
          value = (value+'').substr(0,6);
        } else {
          let value1 = value.substr(0,value.indexOf('.')).substr(0,6);
          let value2 = value.substr(value.indexOf('.'));
          value = value1+value2;
        }
        value = isNaN(value) ? 0 : value; // 不让显示NAN

        collback(value);
      },
      f_passportName(row, column, cellValue, index) {
        if(!row.passportFirstName) {
          row.passportFirstName = "";
        }
        if(!row.passportLastName) {
          row.passportLastName = "";
        }
        return row.passportFirstName + " " +row.passportLastName;
      },
      dateFormat(row, column, cellValue, index) {
        if(cellValue != null) {
          return dateFormat(cellValue);
        } else {
          return cellValue
        }
      },
      saveNationality(row) {
        let params = {
          orderId: row.orderId,
          studentPool: row.studentPool
        };
        https.fetchPost('/mallOrderInfo/update',JSON.parse(JSON.stringify(params)),"json" ).then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if(code == '200') {
          
          } else {
            this.$message({
              type: 'info',
              message: msg
            })
          }
        }).catch(err=>{
              console.log(err)
              this.loading = false;
            }
        )
        
        console.log(row)
        
      },
      
      
      
      changeTime(val) {
        if(val && val.length == 2) {
          this.searchData.paymentTimeStart = val[0];
          this.searchData.paymentTimeEnd = val[1];
        } else {
          this.searchData.paymentTimeStart = "";
          this.searchData.paymentTimeEnd = "";
        }
      },
      exportExcel() {
        // excelCreateTimeStart
        // excelCreateTimeEnd

        let params = this.searchData;
        params['excelCreateTimeStart'] = this.searchData.paymentTimeStart;
        params['excelCreateTimeEnd'] = this.searchData.paymentTimeEnd;

        https.fetchPost('/mallOrderInfo/export',params ,"","" ,"blob").then((data) => {
          let file = data.data;
          let filePath = URL.createObjectURL(file);
          var link = document.createElement('a')
          link.href = filePath;
          link.download = decodeURI(data.headers.filename);
          link.click();
          URL.revokeObjectURL(link.href)
        }).catch(err => {
              console.log(err);
              this.$message.error('网络异常！');
            }
        )

        //window.location.href = https.baseURL+"/mallOrderInfo/excelByMallOrderInfo?"+qs.stringify(params);
      },
      pay(index,row) {
        this.$confirm('该操作将修改此订单状态为已支付，确认支付?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = {
            orderId: row.orderId,
            userName: row.userName,
            paymentStatus: 1
          };
          https.fetchPost('/mallOrderInfo/updateMallOrderInfoVoByOrderId', params, "json").then((data) => {
            let code = data.data.code;
            let msg = data.data.msg;
            if (code == '200') {
              this.$message({
                type: 'success',
                message: '重置成功!'
              });
              this.onSubmit();
            } else {
              this.$message({
                type: 'info',
                message: '重置失败' + msg
              });
            }
          }).catch(err => {
                this.$message.error('网络异常！');
              }
          )

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
      },
      confirmBill(index,row) {
        this.$confirm('确认开票?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = {
            orderId: row.orderId,
            isdrawBill: 1
          };
          https.fetchPost('/mallOrderInfo/updateMallOrderInfoVoByOrderId', params, "json").then((data) => {
            let code = data.data.code;
            let msg = data.data.msg;
            if (code == '200') {
              this.$message({
                type: 'success',
                message: '操作成功!'
              });
              this.onSubmit();
            } else {
              this.$message({
                type: 'info',
                message: msg
              });
            }
          }).catch(err => {
                this.$message.error('网络异常！');
              }
          )

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
      },

      pos(index, row) {
        this.$router.push({
          name: "posPay",
          params: row
        })
      },
      detail(row) {
        this.$router.push({
          name: "orderyhDetail",
          query: {orderId: row.orderId},
        })
      },
      onSubmit(val) {
        if(val) {
          this.searchData.page = val;
        } else {
          this.searchData.page = 1;
          this.currentPage = 1;
        }
        this.searchData.size = this.pageSize;
        let params = this.searchData;
        this.loading = true;
        https.fetchPost('/mallOrderInfo/backList',JSON.parse(JSON.stringify(params)),"json" ).then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if(code == '200') {
            this.staffData = data.data.data;
            this.total = data.data.total;
            this.loading = false;
          } else {
            this.loading = false;
            this.$message({
              type: 'info',
              message: msg
            })
          }
        }).catch(err=>{
              console.log(err)
              this.loading = false;
              this.$message.error('数据加载失败');
            }
        )
      },
      handleSizeChange() {},

      handleCurrentChange(val) {
        this.onSubmit(val);
      },
      selectOrg() {
        https.fetchGet('/managerOrganization/getOrganizationList','', 'from' ).then((data) => {
          let code = data.data.code;
          if(code == 200) {
            this.org = data.data.data;
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }

        }).catch(err=>{
              this.$message.error('网络错误');
            }
        );
      },
    },
    filters: {
      payFilter(val) {
        if(val) {
          return val
        } else {
          return "--"
        }
      },
      dateFormatFilter(val) {
        return dateFormat(val).substr(0,10);
      },
      dateFormatFilter1(val) {
        return dateFormat(val).substr(0,16);
      },
      sexFilter(val) {
        if(val == 0) {
          return '保密';
        }
        if(val == 1) {
          return '女';
        }
        if(val == 2) {
          return '男';
        }
      }
    },
    created: function () {
      this.loginOrgCode = this.$store.state.orgCode;
      this.onSubmit();
      this.selectOrg();
    }
  };
</script>

<style scoped>
    .but-cls {
        margin-bottom: 10px;
    }
    .cls-col {
        margin-right: 20px;
    }
</style>

